/* Presentation attributes only: no policy text, HTML, or commerce data writes. */
(() => {
  const normalizeTitle = text => text.replace(/\s+/g, ' ').trim().toLocaleLowerCase('en');

  function initPolicyReading(scope) {
    scope.querySelectorAll('.shopify-policy__container').forEach(container => {
      const body = container.querySelector('.shopify-policy__body .rte');
      const title = container.querySelector('.shopify-policy__title h1');
      if (!body || !title) return;

      const first = body.firstElementChild;
      if (first && /^H[2-6]$/.test(first.tagName) &&
          normalizeTitle(first.textContent) === normalizeTitle(title.textContent)) {
        first.setAttribute('data-fxl-policy-repeat-title', '');
      }

      body.querySelectorAll('h2, h3, h4, h5, h6').forEach(heading => {
        if (!heading.textContent.trim() &&
            !heading.querySelector('img, svg, video, audio, iframe, table, button, input, hr')) {
          heading.setAttribute('data-fxl-policy-empty-heading', '');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPolicyReading(document), { once: true });
  } else {
    initPolicyReading(document);
  }
})();
